export const isInIframe = (): Boolean => {
	try {
		return window.self !== window.top
	} catch ( error ) {
		// Assume we are in iframe if access is blocked
		return true
	}
}

export const postNavigateMessage = ( href: string, target: string = '_blank' ) => {
	window.parent.postMessage( {
		type: 'navigate',
		target,
		href,
	}, '*' )
}

export const openExternalLink = ( href: string ) => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if ( isInIframe() ) {
		postNavigateMessage( href )
		return
	}

	window.open( href, '_blank', 'noopener,noreferrer' )
}

// This message might not be able to show based on our intercom setup.
// But including it in case it will work sometime in the future.
export const showIntercom = ( message: string = '' ) => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if ( isInIframe() ) {
		window.parent.postMessage( {
			type: 'intercom:open',
			payload: {
				message,
			},
		}, '*' )
	}
}
